import React from "react";
import { fmtMoney, fmtPct } from "@/lib/format";

export const KpiCard = ({ label, value, sub, accent = "cyan", target, delay = 0, testId }) => {
  const accents = {
    cyan: "before:bg-cyan-400",
    emerald: "before:bg-emerald-400",
    amber: "before:bg-amber-400",
    rose: "before:bg-rose-400",
    slate: "before:bg-slate-500",
  };
  return (
    <div
      data-testid={testId}
      className={`ns-rise relative overflow-hidden rounded-xl border border-[#1E2D4A] bg-[#17233B]/80 p-5 backdrop-blur-sm transition-all duration-300 hover:border-[#2D3F62] hover:bg-[#1E2D4A]/60 before:absolute before:left-0 before:top-0 before:h-full before:w-[3px] ${accents[accent]}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400">{label}</div>
      <div className="mt-2 font-mono-fin text-2xl font-bold tracking-tight text-slate-50 sm:text-[28px]">{value}</div>
      {sub && <div className="mt-1.5 text-xs text-slate-400">{sub}</div>}
      {target !== undefined && target !== null && (
        <div className="mt-2 inline-flex items-center rounded-full bg-slate-800/60 px-2 py-0.5 text-[10px] font-medium text-slate-400">
          Target {typeof target === "number" ? fmtPct(target) : target}
        </div>
      )}
    </div>
  );
};

export const MoneyKpi = (props) => <KpiCard {...props} value={fmtMoney(props.amount)} />;
